import React, {Component} from "react";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {configProspectReport} from "./config";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { mapToObjectDDL } from "../../../../common/mapper";
import * as R from 'ramda';
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class ReportStatistic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            kodeCabang:null,
            dataCabang:[],
            dataTL:[],
            teamLead:null
        };
    };

    componentDidMount() { 
        if(this.props.tab === 'salesman'){
            this.fetchDataTL();
        }
     }

    // componentDidUpdate(prevProps, prevState) {
    //   if(!R.equals(JSON.stringify(prevProps.search),JSON.stringify(this.props.search))){
    //       this.handleSearch()
    //   }
    //   if(this.props.tab==='salesman' & !R.equals(prevProps.kodeCabang,this.props.kodeCabang)){
    //       this.fetchDataTL();
    //   }
    // } 

    componentDidUpdate(prevProps) {
      if (
        this.props.tab === "tl" &&
        prevProps.searchKey !== this.props.searchKey
      ) {
        this.fetchData();
      }
    
      if (
        this.props.tab === "salesman" &&
        prevProps.kodeCabang !== this.props.kodeCabang
      ) {
        this.fetchDataTL();
      }
    }


    handleSearchValueChange = (name,value) => {
        this.setState((prev) => ({
          ...prev,
          [name]: value,
        }));
    }

    fetchDataTL = async () => {
       try{
        this.props.triggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
            setError: this.props.setError,
            menuName: "Dashboard Level CRM Salesman CS - Laporan Statistik Prospek per TL",
            args: {paramFilters: {kodeCabang: this.props.kodeCabang, userNameLead: this.props.userNameLead}},
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTL: res.data.data,
            }));
        }
        this.props.triggerLoading();
       }catch(e){
        this.props.triggerLoading();
        console.log(e, "error");
       }
    };

    fetchData = async (payload) => {
      console.log(this.props.tab);
      
      const userId = localStorage.getItem("userId");
       this.props.triggerLoading();
       let employeeId = undefined;
       if(this.props.tab === "salesman"){
        employeeId = this.state.teamLead
          ? this.state.teamLead?.value
          : undefined;
       } 
       let res = await fetchDataAsync({
         asyncFn: this.props.tab === "salesman" ? Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikSalesCS :  Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikTeamLead,
         menuName:
           "Dashboard Koordinator - Laporan Prospek Monitoring Tim",
         setError: this.props.setError,
         args: {
           kodeCabangList: [this.props.search.kodeCabang],
           month: this.props.search.month,
           year: this.props.search.year,
           teamLeaderEmployeeId: this.props.tab === "salesman" ? employeeId : userId,
          //  employeeIdTeamLeader: this.props.tab !== "salesman" ? this.props.idLeader : undefined,
           salesEmployeeId: null
         },
       });

       if (res.ok && res.data.status === HttpStatus.SUCCESS) {
         this.setState((prevValue) => ({
           ...prevValue,
           dataTable: res.data.data || [],
         }));
       }
       this.props.triggerLoading();
    };

    handleSearch = () =>{
        this.fetchData()
    }

    render() {
        let {dataTable} = this.state;
        return (
          <>
            {R.equals(this.props.tab,'salesman') && (
              <FlexView style={{ gap: "20px", alignItems: "center" }}>
                <SimpleDDL
                  id="select_options_kode_cabang"
                  box="search"
                  name="teamLead"
                  isClearable
                  containerclassname="width width-250px"
                  placeholder="Nama TL"
                  menuPosition="fixed"
                  options={this.state.dataTL?.map((item) =>
                    mapToObjectDDL(item.salesLeadName, item.employeeId)
                  )}
                  value={this.state.teamLead}
                  onChange={(value, { name }) =>
                    this.handleSearchValueChange(name, value)
                  }
                />
                <SimpleButton
                  styles={{ marginBottom: "15px" }}
                  onClick={() => this.handleSearch()}
                >
                  Cari
                </SimpleButton>
              </FlexView>
            )}
            <SimpleDataTable data={dataTable} columns={configProspectReport(this.props.tab)} />
          </>
        );
    };
}

export default ReportStatistic;